import { AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

enum WriteWithAITabName {
  FILE = 'FILE',
  TEXT = 'TEXT',
  URL = 'URL',
}

const FileValidations = Yup.object().shape({
  files: Yup.array(Yup.object()),
});

const TextValidations = Yup.object().shape({
  embeddedAttachments: Yup.array(Yup.object()),
  text: Yup.array(
    Yup.object().shape({
      text: Yup.string().required('Please enter context'),
      embeddedAttachments: Yup.array(Yup.object()),
      isLoadingFiles: Yup.boolean(),
    }),
  ),
});

const URLValidations = Yup.object().shape({
  url: Yup.string().required('Please enter the url'),
});

const Validations = {
  [WriteWithAITabName.FILE]: FileValidations,
  [WriteWithAITabName.TEXT]: TextValidations,
  [WriteWithAITabName.URL]: URLValidations,
};

type StreamedResponseContext = {
  loading: boolean;
  genAIResponse: string;
  isStreaming: boolean;
  articleMetaData: {
    title: string;
    description: string;
    attachments: AttachmentType[];
  };
};

export type WriteWithAIFormValues = {
  text: ({
    isLoadingFiles: boolean;
    embeddedAttachments: AttachmentType[];
    text: string;
  } & StreamedResponseContext)[];
  files: AttachmentType[];
  url: string;
};

export const DEFAULT_TEXT_FIELD = {
  text: '',
  isLoadingFiles: false,
  embeddedAttachments: [],
  loading: false,
  genAIResponse: '',
  isStreaming: false,
  articleMetaData: {
    title: '',
    description: '',
    attachments: [],
  },
};

function useWriteWithAIForm({
  defaultPrompt = '',
  tab,
}: {
  defaultPrompt?: string;
  tab: WriteWithAITabName;
}) {
  const formState = useForm<WriteWithAIFormValues>({
    resolver: yupResolver(Validations[tab]),
    defaultValues: {
      files: [],
      text: [{ ...DEFAULT_TEXT_FIELD, text: defaultPrompt }],
      url: '',
    },
  });

  return {
    formState,
  };
}

export default useWriteWithAIForm;
